<template>
  <div class="dropdown-button" :class="className">
    <button class="dropdown-button__button" @click="isOpen = !isOpen">
      <slot />
      <slot name="icon" />
    </button>

    <div class="dropdown-button__content" v-show="isOpen">
      <div
        class="content-item"
        v-for="option in options"
        :key="option.value"
        @click="handleOptionClick(option)"
      >
        <span v-if="option.isSelected" class="content-item__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.8047 3.52864C14.0651 3.78899 14.0651 4.2111 13.8047 4.47145L6.4714 11.8048C6.21105 12.0651 5.78895 12.0651 5.5286 11.8048L2.19526 8.47145C1.93491 8.2111 1.93491 7.78899 2.19526 7.52864C2.45561 7.26829 2.87772 7.26829 3.13807 7.52864L6 10.3906L12.8619 3.52864C13.1223 3.26829 13.5444 3.26829 13.8047 3.52864Z"
              fill="#465669"
            />
          </svg>
        </span>
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownButton",
  props: {
    className: {
      type: String,
      required: false,
      default: ""
    },
    options: {
      type: Array,
      required: true,
      validator: value => {
        return value.every(item => {
          return typeof item === "object" && item !== null && "label" in item && "value" in item
        })
      },
      default: () => []
    },
    closeOnOptionClick: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    handleOptionClick(option) {
      if (this.closeOnOptionClick) {
        this.isOpen = false
      }

      if (option.onClick) {
        option.onClick(option.value)
      }
    }
  },
  watch: {
    isOpen(value) {
      if (value) {
        document.addEventListener("click", this.handleClickOutside)
      } else {
        document.removeEventListener("click", this.handleClickOutside)
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside)
  }
}
</script>

<style lang="scss" scoped>
.dropdown-button {
  position: relative;
  z-index: 10;

  &__button {
    display: flex;
    min-height: 36px;
    padding: 0.5rem 1rem;
    align-items: center;
    gap: 1rem;
    border-radius: 0.25rem;
    background: var(--color-primary-10);
    color: var(--color-neutral-70);
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-decoration: none;
    border: none;
    box-shadow: none;
    outline: none;
    cursor: pointer;

    &:hover,
    &:active {
      background: linear-gradient(0deg, var(--color-gray-100-10) 0%, var(--color-gray-100-10) 100%),
        var(--color-primary-10);
    }
  }

  &__content {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: max-content;
    max-width: 420px;
    background-color: var(--color-gray-00);
    border-radius: 0.25rem;
    border: 1px solid var(--color-neutral-50);
    background: var(--color-neutral-30);
    box-shadow: var(--shadow-elevate);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .content-item {
      padding: 0.5rem;
      background-color: var(--color-neutral-00);
      color: var(--color-neutral-90);
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.5rem;

      &:hover,
      &:active {
        background-color: var(--color-neutral-10);
      }

      &:not(:last-child) {
        border-bottom: 1px solid var(--color-neutral-30);
      }

      &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
